import React from 'react';
interface ProjectCreatedPopupProps {
  pid?: string;
  locationSite: string;
  actions: string[];
  onClose: () => void;
  onCreateAnother?: () => void;
  onViewList: () => void;
  hideCreateAnother?: boolean;
  title?: string;
  projectTitle: string;
}
const ProjectCreatedPopup: React.FC<ProjectCreatedPopupProps> = ({
  pid,
  locationSite,
  actions,
  onClose,
  onCreateAnother,
  onViewList,
  hideCreateAnother,
  title = 'New Project Created Successfully!',
  projectTitle,
}) => {
  return (
    <div className=" fixed inset-0 left-[255px] bg-[#E5DCE1CC] bg-opacity-40 flex justify-center items-center z-50">
      {' '}
      <div className="bg-[#621C43] max-w-lg w-full rounded-xl text-white relative shadow-xl border border-[#7a2757]">
        {' '}
        {/* Close button */}{' '}
        <button
          onClick={onClose}
          className="absolute top-2 right-4 text-white hover:text-gray-300 text-xl font-bold"
          aria-label="Close popup"
        >
          {' '}
          &times;{' '}
        </button>{' '}
        {/* Header */}{' '}
        <div className="border-b p-4 border-[#FFF8ED]">
          {' '}
          <h2 className="text-lg font-semibold text-center">{title}</h2>{' '}
        </div>{' '}
        {/* Details */}{' '}
        <div className="text-center mb-5 leading-relaxed text-sm mt-5">
          {' '}
          <p>
            <strong>P ID:</strong> {pid ?? '—'}
          </p>
          <p>
            <strong>Project Name:</strong> {projectTitle}
          </p>
          <p>
            {' '}
            <strong>Location/Site:</strong> {locationSite}{' '}
          </p>{' '}
        </div>{' '}
        {/* Post-Creation Actions */}{' '}
        <div className="mb-6 px-6">
          {' '}
          <p className="text-xs font-semibold mb-2 opacity-90">Post-Creation Actions:</p>{' '}
          <div className="rounded-md flex justify-between text-xs text-[#EEE] font-medium">
            {' '}
            {/* Left side actions */}{' '}
            <div className="flex flex-wrap gap-2">
              {' '}
              {actions.slice(0, Math.ceil(actions.length / 2)).map((action, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2 bg-[#A15C86] bg-opacity-30 rounded px-4 py-1.5"
                >
                  {' '}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-3.5 w-3.5 text-green-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    {' '}
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />{' '}
                  </svg>{' '}
                  {action}{' '}
                </div>
              ))}{' '}
            </div>{' '}
            {/* Right side actions */}{' '}
            <div className="flex flex-wrap gap-2 justify-end">
              {' '}
              {actions.slice(Math.ceil(actions.length / 2)).map((action, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2 bg-[#A15C86] bg-opacity-30 rounded px-3 py-1.5"
                >
                  {' '}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-3.5 w-3.5 text-green-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    {' '}
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />{' '}
                  </svg>{' '}
                  {action}{' '}
                </div>
              ))}{' '}
            </div>{' '}
          </div>{' '}
        </div>{' '}
        {/* Buttons */}{' '}
        <div className="flex justify-between gap-3 p-3 px-6 flex-col sm:flex-row">
          {' '}
          {/* ✅ Only show when allowed */}{' '}
          {!hideCreateAnother && onCreateAnother && (
            <button
              onClick={onCreateAnother}
              className="bg-[#0CA96F] flex-1 hover:bg-[#0b9e68] text-white py-2 rounded-md text-sm"
            >
              {' '}
              Create Another Project{' '}
            </button>
          )}{' '}
          <button
            onClick={onViewList}
            className="flex-1 bg-[#4C86E7] hover:bg-[#4679d1] rounded-md py-2 text-sm"
          >
            {' '}
            View Project List{' '}
          </button>{' '}
        </div>{' '}
      </div>{' '}
    </div>
  );
};
export default ProjectCreatedPopup;
